import React, { useState } from 'react';
import classnames from 'classnames';

import { Subscribe } from '../types';
import { SubscribeConsentDataHooks } from './subscribe-consent-data-hooks';

import * as style from './subscribe-consent.scss';

const RequireConsentComponent: React.FunctionComponent<Subscribe> = (props) => {
  const {
    consentCheckboxText,
    consentLinkText,
    consentLinkUrl,
    isConsentChecked,
    isSubmitted,
    onChange,
    shouldRequireConsent,
    shouldShowConsentLink,
  } = props;

  const [isChecked, setChecked] = useState(isConsentChecked);

  if (!shouldRequireConsent) {
    return null;
  }

  const fontSize = '14px';
  const textStyle = { fontSize, lineHeight: fontSize };
  const checkboxChangeHandler = () => {
    const newValue = !isChecked;
    setChecked(newValue);
    onChange(newValue);
  };
  const showCheckboxError = isSubmitted && !isChecked;
  return (
    <div
      className={style.container}
      data-hook={SubscribeConsentDataHooks.container}
    >
      <label>
        <div className={style.labelContainer}>
          <input
            checked={isChecked}
            className={classnames(
              style.checkbox,
              showCheckboxError && style.error,
            )}
            data-hook={SubscribeConsentDataHooks.checkbox}
            onChange={checkboxChangeHandler}
            type="checkbox"
          />
          <div
            className={classnames('so-global-p1', style.textContainer)}
            style={textStyle}
          >
            <span
              data-hook={SubscribeConsentDataHooks.checkboxLabelText}
              className={style.checkboxText}
            >
              {consentCheckboxText}
            </span>
            {shouldShowConsentLink && (
              <>
                {' '}
                <a
                  className={classnames('so-global-p1', style.checkboxText)}
                  data-hook={SubscribeConsentDataHooks.link}
                  href={consentLinkUrl}
                  rel="noopener noreferrer"
                  style={{ ...textStyle, textDecoration: 'underline' }}
                  target="_blank"
                >
                  {consentLinkText}
                </a>
              </>
            )}
          </div>
        </div>
      </label>
    </div>
  );
};

RequireConsentComponent.defaultProps = {
  isConsentChecked: false,
  isSubmitted: false,
  onChange: () => {},
  shouldRequireConsent: false,
  shouldShowConsentLink: false,
};

export const RequireConsentProps = [
  'consentCheckboxText',
  'consentLinkText',
  'consentLinkUrl',
  'isConsentChecked',
  'isSubmitted',
  'onChange',
  'shouldRequireConsent',
  'shouldShowConsentLink',
];

export const RequireConsent = RequireConsentComponent;
